import React from 'react'

import { Button, Input, InputGroup, Modal } from 'rsuite'

import { Divider, IconButton, Avatar } from '@mui/material'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'

import { BootstrapTooltip } from '../../_ui/tooltip'
import avatar from './../../../img/avatar.svg'
import css from './profile.module.scss'

const Profile = (props: any) => {
    return (
        <>
            <EditProfile {...props} />

            <div className={css.main}>
                <div className={css.header}>
                    <div style={{ margin: "auto -90px auto 0", position: "relative", cursor: "pointer" }}>
                        <BootstrapTooltip title={<div style={{ textAlign: "center" }}><div>Ваша аватарка</div><div>Кликните для изменения</div></div>} placement="top" arrow>
                            <div {...props.getRootProps()}>
                                <Avatar alt="Remy Sharp" src={props.myProfile.avatar || avatar} sx={{ width: 180, height: 180 }} />
                            </div>
                        </BootstrapTooltip>
                    </div>

                    <div className={css.header_body}>
                        <div>
                            <div className={css.operatorFIO}>{`${props.myProfile.lastName} ${props.myProfile.firstName} ${props.myProfile.secondName}`}</div>
                            <div className={css.operatorPosition}>{props.myProfile.position ? props.myProfile.position : "Должность не указана"}</div>
                        </div>

                        <div>
                            <div className={css.operatorPhone}>{props.myProfile.phoneNumber ? `Номер телефона: ${props.myProfile.phoneNumber}` : "Номер телефона не указан"}</div>
                            <div className={css.operatorPhone}>Дата создания аккаунта: {props.myProfile.accountCreateDate}</div>
                        </div>

                        <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

                        <Button appearance="ghost" size="md" color="blue" block onClick={props.openDialogEditProfile}>РЕДАКТИРОВАТЬ МОЙ ПРОФИЛЬ</Button>
                    </div>
                </div>

                <div className={css.body}>
                    <div className={css.body_header}>Мои уровни доступа</div>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

                    <div className={css.body_content}>
                        {!props.myProfile.accessLevel
                            ? ""
                            : props.myProfile.accessLevel.map((level: any) => {
                                return (
                                    <div key={level.accessLevelID} className={css.levelItem}>{level.accessLevelName}</div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

// Окно редактирования профиля оператора
const EditProfile = (props: any) => {
    return (
        <Modal backdrop="static" size="xs" autoFocus={false} open={props.getVisibleEditProfle}>
            <div className="modal">
                <div className="modalHead">
                    Редактирование моего профиля
                </div>

                <div className="modalBody">
                    <div className={css.profile_body}>
                        <div className={css.fieldItems}>
                            <div className={css.itemHead}>Моя фамилия</div>
                            <InputGroup inside>
                                <Input type="text" size="md" placeholder="Фамилия" autoComplete="off"
                                    value={props.valueLastName} onChange={value => props.setValueLastName(value)}
                                />

                                <InputGroup.Addon onClick={() => props.clearDialogEditProfile('lastName')} style={{ margin: "-7px -7px 0 0" }}>
                                    <BootstrapTooltip title="Очистить" placement="right" arrow>
                                        <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                            <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                        </IconButton>
                                    </BootstrapTooltip>
                                </InputGroup.Addon>
                            </InputGroup>
                        </div>

                        <div className={css.fieldItems}>
                            <div className={css.itemHead}>Моё имя</div>
                            <InputGroup inside>
                                <Input type="text" size="md" placeholder="Имя" autoComplete="off"
                                    value={props.valueFirstName} onChange={value => props.setValueFirstName(value)}
                                />

                                <InputGroup.Addon onClick={() => props.clearDialogEditProfile('firstName')} style={{ margin: "-7px -7px 0 0" }}>
                                    <BootstrapTooltip title="Очистить" placement="right" arrow>
                                        <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                            <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                        </IconButton>
                                    </BootstrapTooltip>
                                </InputGroup.Addon>
                            </InputGroup>
                        </div>

                        <div className={css.fieldItems}>
                            <div className={css.itemHead}>Моё отчество</div>
                            <InputGroup inside>
                                <Input type="text" size="md" placeholder="Отчество" autoComplete="off"
                                    value={props.valueSecondName} onChange={value => props.setValueSecondName(value)}
                                />

                                <InputGroup.Addon onClick={() => props.clearDialogEditProfile('secondName')} style={{ margin: "-7px -7px 0 0" }}>
                                    <BootstrapTooltip title="Очистить" placement="right" arrow>
                                        <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                            <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                        </IconButton>
                                    </BootstrapTooltip>
                                </InputGroup.Addon>
                            </InputGroup>
                        </div>

                        <div className={css.fieldItems}>
                            <div className={css.itemHead}>Моя должность</div>
                            <InputGroup inside>
                                <Input type="text" size="md" placeholder="Должность" autoComplete="off"
                                    value={props.valuePosition} onChange={value => props.setValuePosition(value)}
                                />

                                <InputGroup.Addon onClick={() => props.clearDialogEditProfile('position')} style={{ margin: "-7px -7px 0 0" }}>
                                    <BootstrapTooltip title="Очистить" placement="right" arrow>
                                        <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                            <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                        </IconButton>
                                    </BootstrapTooltip>
                                </InputGroup.Addon>
                            </InputGroup>
                        </div>

                        <div className={css.fieldItems}>
                            <div className={css.itemHead}>Мой номер телефона</div>
                            <InputGroup inside>
                                <InputGroup.Addon>+7</InputGroup.Addon>

                                <Input type="text" size="md" placeholder="Номер телефона" autoComplete="off"
                                    value={props.valuePhoneNumber} onChange={value => props.setValuePhoneNumber(value)}
                                />

                                <InputGroup.Addon onClick={() => props.clearDialogEditProfile('phoneNumber')} style={{ margin: "-7px -7px 0 0" }}>
                                    <BootstrapTooltip title="Очистить" placement="right" arrow>
                                        <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                            <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                        </IconButton>
                                    </BootstrapTooltip>
                                </InputGroup.Addon>
                            </InputGroup>
                        </div>
                    </div>
                </div>

                <div className="modalFooter">
                    <Button size="md" appearance="default" onClick={props.closeDialogEditProfile}>ОТМЕНА</Button>
                    <Button size="md" appearance="primary" onClick={props.applyEditProfile}>ПРИМЕНИТЬ</Button>
                </div>
            </div>
        </Modal>
    )
}

export default Profile